<template>
  <div class="lead-update-business-kits lead-mask gutter-xs row">
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
      <h3>{{$t('ui.business_kit.send')}}</h3>

      <tag-list
        label="Tags"
        name="tags"
        :value="item.tags"
        @input="tagUpdate"
      />

      <div v-if="items.length > 0">
        <field
          class="businesskit-select"
          model="business_kit"
          name="select"
          :params="{no_i18n: true}"
          type="select"
          :collection="items"
          :value="business_kit_id"
          @input="emitBusinessKitId"
        />
        <div class="preview-bk">
          <a :href="this.selected_businesskit_url" target="_blank" rel="noopener noreferrer" class="link is-margin-bottom-20">
            {{ $t('ui.business_kit.preview') }}
          </a>
        </div>

        <div class="field field-checkbox">
          <div class="field--wrapper">
            <div class="field--checkbox">
              <input type="checkbox" id="authorization" v-model="authorization" class="input--checkbox" value=true>
              <label for="authorization">{{$t('ui.business_kit.confirmation')}}</label>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        {{$t('ui.pages.lead-no-businesskit')}}
      </div>

      <div class="actions">
        <button @click="send_businesskit" :disabled="!authorization" class="btn btn-primary" :class="{'is-disabled': !business_kit_id || !authorization || loading, '': loading}">{{$t('ui.business_kit.send_confirm')}}</button>
      </div>
      <div v-if="this.redirect_url" class='message'>
        <p :class='messageType'>
          {{messageContent}}
        </p>
        <a :href='this.redirect_url' target="_blank" rel="noopener noreferrer" class="link is-margin-bottom-20">{{this.$t('models.business_kit.create_template')}}</a>
      </div>
      <div v-else class='message'>
        <p :class='messageType'>
          {{messageContent}}
        </p>
      </div>
    </div>
    <div class="bk-activity col-xs-12 col-sm-12 col-md-5 col-lg-5 offset-md-1">
      <div v-if="!businesskit_history.length" class="empty-state-bk-history">
        <img src="../../../../assets/empty-default.svg" alt="">
        <p>{{$t('ui.business_kit.activity')}}</p>
      </div>
      <h3 v-if="businesskit_history.length">
        {{$t('ui.business_kit.history')}}
      </h3>
      <div class="" v-if="businesskit_history.length">
        <div class="truncate-text" v-for="bk in businesskit_history" :key="bk.eventbaxx_event_name">
              <a class="link" :href="bk.bag_url" target="_blank">{{bk.eventbaxx_event_name}}</a>
            <p class="bk-history--date">
              {{$t('models.business_kit.status.' + bk.status)}} on {{moment(bk.transferred_at).format("DD.MM.YYYY - HH:mm")}}
            </p>
          <div class="bk-history--mobile">
            <p>
              {{moment(bk.transferred_at).format("DD.MM.YYYY HH:mm")}}<br/>
              <a :href="bk.bag_url" target="_blank">{{bk.eventbaxx_event_name}} - {{$t('models.business_kit.status.' + bk.status)}}</a>
            </p>
          </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Api from "@/api/BusinessKit"
import Field from '@/components/helpers/DataInput/Field'
import LeadApi from "@/api/Lead"
import TagList from "@/components/helpers/DataInput/TagList"
import Permissions from "@/classes/Permission"

export default {
  props: {
    project_id: {
      type: [String, Number],
      required: true
    },
    id: {
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    business_kit_id: {
      required: true
    }
  },
  components: {
    Field,
    TagList
  },
  data(){
    return{
      items: [],
      authorization: false,
      loading: false,
      messageType: '',
      messageContent: '',
      businesskit_history:[],
      selected_businesskit_url: "",
      redirect_url: undefined,
      errors: [],
      moment
    }
  },
  computed: {
    allowedStatistics() {
      return Permissions.planCan('allowed_statistics')
    }
  },
  created(){
    this.retrieve()
  },
  mounted(){
    this.authorization = this.item.opt_in_businesskit
  },
  methods: {
    tagUpdate(content){
      this.$emit("input","tags",content)
    },
    send_businesskit(){
      if(this.authorization == true) {
      let callback = (messageType, messageContent)=>{
        // Reset url
        this.redirect_url = undefined
        // If it's a missing template we want to link to where they can create it
        if (messageContent == 'models.business_kit.missing.email') {
          this.redirect_url = 'https://businesskit.fanomena.io/events/'+this.business_kit_id+'/schedules/new_email'
        }
        this.messageContent = this.$t(messageContent)
        this.messageType = messageType
        this.loading = false
      }
      this.loading = true
      this.$emit("send_businesskit", callback)
      }
    },
    retrieve(){
      let api = new Api()
      api.all({project_id: this.project_id}).then((result) => {
        var items = []
        result.resources.forEach((bk) => {
          items.push({
            "name": bk.name,
            "value": bk.id,
            "url": bk.preview_url
          })
        })
        this.items = items
        // We emit the specific item association
        if (items.length !== 0) {
          this.emitBusinessKitId(items[0].value)
        }
      })
      this.fetchBkStats()

      if(this.item.opt_in_businesskit){
        this.authorization = this.item.opt_in_businesskit
      }
    },
    fetchBkStats() {
      if (this.allowedStatistics) {
        let lead_api = new LeadApi()
        lead_api.statistics(this.id).then((item) => {
          this.businesskit_history = item.businesskit_history
        }).catch((error) => {
        })
      }
    },
    emitBusinessKitId(val){
      this.$emit('bkIdChange', val)
    }
  },
  watch: {
    item: {
      deep:true,
      handler(){
        this.authorization = this.item.opt_in_businesskit
      }
    },
    authorization(){
      this.$emit("input","opt_in_businesskit",this.authorization)
    },
    allowedStatistics() {
      this.fetchBkStats()
    },
     // we are watching business kit id changes
    business_kit_id(){
      this.emitBusinessKitId(this.business_kit_id)
      this.items.forEach((item) => {
        if (item.value == this.business_kit_id) {
          this.selected_businesskit_url = item.url
        }
      })
    }
  },
}
</script>

<style lang="scss">

.lead-update-business-kits{

  h3{
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 20px !important;
    color: $ink;
  }
  .actions .btn{
    min-width: 250px;
  }
  .preview-bk {
    margin: 0px 0 20px;
  }

  .bk-history {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .field--checkbox{
    label{
      font-size: 1.1em;
      line-height: 20px;
      font-weight: 400;
      display: block;
      padding-left: 2em;
      &:after, &:before{
        margin-top: 0;
      }
    }
    margin-top: 2em;
  }
  .actions{
    margin-top: 1em;
    text-align: left;

      .btn{
        width: 100%;
        position: relative;
      }
      .loader {
        position: absolute;
      }
  }
}
.message{
  text-align: left;
  margin-top: .4em;
  .message-success{
    color: $color-success;
  }
  .message-error{
    color: $color-danger;
  }
}

.empty-state-bk-history {
  text-align: center;

  p {
    color: $ink-lighter;
    margin-top: .5em;
  }
}

.bk-history{
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 24px;
  th{
    text-align: left;
    font-weight: normal;
  }

  a {
    cursor: pointer;
  }
  td,th{
    margin-bottom: 1em;
  }
}

.bk-history--name{
  width: 100%;
  margin: 0;
  a{
    text-decoration: none;
    vertical-align: bottom;
  }
  @include respond-to("small") {
    display: none;
  }
  a {
    color: $ink-light;
    font-size: 14px;
    font-weight: 500;
  }
}
.bk-history--date{
  width: 100%;
  color: $ink;
  font-size: 12px;
  font-weight: 400;
  margin: .5em 0 0;
  @include respond-to("small") {
    display: none;
  }

}
.bk-history--mobile{
  display: none;
  @include respond-to("small") {
    display: table-cell;
  }
}
</style>



// WEBPACK FOOTER //
// LeadUpdateBusinessKit.vue?e955d9f8